<template>
	<v-dialog
		:max-width="maxWidth"
		:fullscreen="fullscreen"
		:value="open"
		:persistent="persistent"
		@input="onInput($event)">
		<v-card>
			<v-card-title
				v-if="title"
				class="headline"
        primary-title
			>{{title}}</v-card-title>
			<v-divider />
			<slot></slot>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		maxWidth: String,
		value: Boolean,
		fullscreen: Boolean,
		title: String,
		persistent: Boolean,
	},
	computed: {
		open() {
			return this.value
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
	},
}
</script>

<style>
	#app .v-dialog, #app .v-dialog .v-card {
		border-radius: 0;
		box-shadow: none;
	}
</style>
